import type { AttentionType } from '@kainos/shared';
import type { AttentionItem } from '@kainos/validation';
import { http } from '@/lib/api';
import { config } from '@/lib/config';
import { mockApi } from '@/mocks/mock-api';

export interface AttentionFilters {
  type?: AttentionType;
  projectId?: string;
}

/**
 * Lists everything that needs a person's attention across the tenant.
 *
 * The backend composes this read model with `buildAttentionItems`; the frontend
 * only renders it, so the prioritisation rules live in exactly one place.
 */
export function getAttentionItems(filters: AttentionFilters = {}): Promise<AttentionItem[]> {
  if (config.useMocks) return mockApi.listAttention(filters.type);

  return http.get<AttentionItem[]>('/attention', {
    query: { type: filters.type, projectId: filters.projectId },
  });
}
